import { initials } from '../../utils/profile/profile'

type AvatarProps = {
  name: string
  image?: string | null
  size?: 'sm' | 'lg' | 'xl'
  className?: string
}

const Avatar = ({ name, image, size, className }: AvatarProps) => (
  <div className={['ph-avatar', size, className].filter(Boolean).join(' ')}>
    {image ? <img src={image} alt={name} /> : initials(name)}
  </div>
)

export default Avatar
